module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-13-7dbf469be63a4c8ae767d40846177db7.svg";